import axiosInstance from '../config/axiosInstance';
import { ENDPOINTS } from '../config/apiConfig';

interface ApiResponse {
  message: string;
  data: any; // Define the structure of the response here
  status: string;
  code : any;
}

export const saveIntakeForm = async (data: any) => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.insertFormData + '/saveIntakeForm', data);
      return response.data; // Return the response data
    } catch (error) {
      throw error; // Rethrow the error for handling in the component
    }
  };
  
 
  
  export const getProjectDetails = async (
    // requestedBy: string, 
    ritmNumber: string
  ) => {
    try {
      const response = await axiosInstance.get(
        `${ENDPOINTS.insertFormData}/getProjecDetails?RITM_number=${ritmNumber}`
      );
      
      return response.data;
    } catch (error) {
      console.error('Error fetching project details:', error);
      throw new Error('Failed to fetch project details');
    }
  };
  
  export const saveFiles = async (payload: any) => {
    try {
      // Make the API POST call to save the files
      const response = await axiosInstance.post(ENDPOINTS.insertFormData + '/saveFiles', payload);
      return response.data; // Return the API response
    } catch (error) {
      console.error('Error saving files:', error);
      throw error; // Rethrow to be handled by the caller
    }
  };
  